<script setup lang="ts" generic="MM">
import FormField from '@/components/input/FormField.vue'

const props = defineProps<{
  label: string
}>()
// expose v-model for TS so `<color-picker v-model="..." />` is typed
const model = defineModel<string>({ required: false })
</script>

<template>
  <form-field :label="props.label">
    <v-color-picker
      v-model="model"
      v-bind="$attrs"
      mode="hex"
      show-swatches
      hide-canvas
      hide-sliders
      width="100%"
      swatches-max-height="100"
    />
  </form-field>
</template>
